/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import config from '../config/config';

export const getCompanyLoginOptions = async (
  domain: string,
): Promise<{
  logoUrl: string | null;
  loginMessage: string | null;
  hasMagicLinks: boolean | null;
}> => {
  // this route is an unauthenticated route so you need to use axios and not the api client
  const { data } = await axios(
    `${config.milestonesAPIBaseUrl}/login-options/?domain=${domain}`,
  );
  return data;
};
